/**
 * Shared by the mobile top bar and the nav header so the logo and the
 * menu/close button keep their position when the nav opens.
 */
export const TOP_BAR_HEIGHT = 56;
